import { FC } from "react";

import { CountUpText } from "../../../CountUpText/CountUpText";

import { StatCardProps } from "./StatCard.type";

/**
 * One sentence with its figure set large, in the place the sentence already put it. Two type
 * sizes only: the number, and everything around it. That is what gives the count-up something
 * to land on — inside an evenly set paragraph the same animation reads as a fidget.
 */
const StatCard: FC<StatCardProps> = ({ item }) => {
	const { iconUrl, before, value, after, source } = item;

	return (
		<div className="h-full flex flex-col gap-3 rounded-xl border border-gray-200 bg-white p-5 md:p-6 shadow-sm">
			{/* Decorative. The sentence already says what the icon illustrates, so giving it alt
			    text would only have a screen reader announce the card twice. */}
			<img src={iconUrl} alt="" aria-hidden="true" className="w-14 h-14" />

			{/* Still one paragraph, because it is still one sentence — the three parts are blocked
			    out with `display: block` rather than split into separate elements, so a screen
			    reader reads it as the sentence it is. Set inline, the figure's line box shouldered
			    the lines around it and left the copy looking ragged. */}
			<p className="leading-relaxed">
				{before ? <span className="block" dangerouslySetInnerHTML={{ __html: before }} /> : null}

				{/* `secondary`, not `primary`: the light brand blue only reaches ~2.4:1 on white. */}
				<CountUpText
					as="span"
					className="block my-2 text-3xl lg:text-4xl font-black text-secondary leading-none"
					html={value}
				/>

				{after ? <span className="block" dangerouslySetInnerHTML={{ __html: after }} /> : null}
			</p>

			{/* `mt-auto` pins the source to the bottom edge, so attributions line up across a row
			    of equal-height cards. Small caps rather than a third body size: it reads as a
			    label instead of adding another voice to the sentence above it. */}
			{source ? <p className="mt-auto pt-1 text-xs uppercase tracking-wide text-gray-500">{source}</p> : null}
		</div>
	);
};

export { StatCard };
